<template>
  <div class="Register">
    <v-form ref="form" v-model="valid">
      <v-container>
        <v-layout row wrap>
          <div id="reg">
            <h1 id="regHeading">Registrieren:</h1>
            <v-divider></v-divider>
            <v-flex>
              <v-text-field v-model="firstName" :rules="nameRules" required label="Vorname *" class="txtField"></v-text-field>
            </v-flex>

            <v-flex>
              <v-text-field v-model="lastName" :rules="nameRules" required label="Nachname *" class="txtField"></v-text-field>
            </v-flex>

            <v-flex>
              <v-text-field v-model="skiName" label="Name der Gesellschaft" class="txtField"></v-text-field>
            </v-flex>

            <v-flex>
              <v-text-field v-model="eMail" :rules="emailRules" required label="E-Mail *" class="txtField"></v-text-field>
            </v-flex>

            <v-flex>
              <v-text-field v-model="password" :rules="passwordRules" required label="Passwort *" class="txtField" :type="'password'"></v-text-field>
            </v-flex>

            <v-flex>
              <v-checkbox label="Ich bin mit den AGB einverstanden *" :rules="[v => !!v || 'Sie müssen zustimmen um fortzufahren!']" required class="txtField" v-model="accepted">
              </v-checkbox>
            </v-flex>

            <v-dialog v-model="dialog" width="800" :retain-focus="false">
              <template v-slot:activator="{ on }">
                <v-btn color="blue" small outlined rounded slot="activator" v-on="on">
                  <span style="font-size: 130%;">AGB</span>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar color="#2E9AFE" height="50px">
                  <v-toolbar-title style="color: white; font-size: 150%">Allgemeine Geschäftsbedingungen</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-btn small @click="dialog = false" icon>
                    <v-icon color="white">fas fa-times</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-card-text>
                  <h1 style="font-size: 200%">Datenschutzerklärung</h1>
                  <br>
                  <div class="AGBbox">
                    Personenbezogene Daten (nachfolgend zumeist nur „Daten“ genannt) werden von uns nur im Rahmen der Erforderlichkeit sowie zum Zwecke der Bereitstellung eines funktionsfähigen und nutzerfreundlichen Internetauftritts, inklusive seiner Inhalte und der dort angebotenen Leistungen, verarbeitet.
                    Gemäß Art. 4 Ziffer 1. der Verordnung (EU) 2016/679, also der Datenschutz-Grundverordnung (nachfolgend nur „DSGVO“ genannt), gilt als „Verarbeitung“ jeder mit oder ohne Hilfe automatisierter Verfahren ausgeführter Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten, wie das Erheben, das Erfassen, die Organisation, das Ordnen, die Speicherung, die Anpassung oder Veränderung, das Auslesen, das Abfragen, die Verwendung, die Offenlegung durch Übermittlung, Verbreitung oder eine andere Form der Bereitstellung, den Abgleich oder die Verknüpfung, die Einschränkung, das Löschen oder die Vernichtung.
                    Mit der nachfolgenden Datenschutzerklärung informieren wir Sie insbesondere über Art, Umfang, Zweck, Dauer und Rechtsgrundlage der Verarbeitung personenbezogener Daten, soweit wir entweder allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung entscheiden. Zudem informieren wir Sie nachfolgend über die von uns zu Optimierungszwecken sowie zur Steigerung der Nutzungsqualität eingesetzten Fremdkomponenten, soweit hierdurch Dritte Daten in wiederum eigener Verantwortung verarbeiten.
                    Unsere Datenschutzerklärung ist wie folgt gegliedert:
                    <br>I. Informationen über uns als Verantwortliche
                    <br>II. Rechte der Nutzer und Betroffenen
                    <br>III. Informationen zur Datenverarbeitung
                  </div>
                  <br>
                  <div class="AGBbox">
                    <strong class="AGBheading">I. Informationen über uns als Verantwortliche</strong>
                    <br>Verantwortlicher Anbieter dieses Internetauftritts im datenschutzrechtlichen Sinne ist:
                    <br>V.A.M. Innsbruck
                    <br>Prüfzentrum für Werkstoffe und Maschinenbau
                    <br>Anichstraße 26 – 28
                    <br>6020 Innsbruck
                    <br>T +43-50902 808 750
                    <br>F +43-50902 808 901
                    <br>info(at)vam-innsbruck.at
                    <br>
                    <br>Datenschutzbeauftragte/r beim Anbieter ist:
                    <br>Johannes Mayr
                  </div>
                  <br>
                  <div class="AGBbox">
                    <strong class="AGBheading">II. Rechte der Nutzer und Betroffenen</strong>
                    <br>Mit Blick auf die nachfolgend noch näher beschriebene Datenverarbeitung haben die Nutzer und Betroffenen das Recht
                    auf Bestätigung, ob sie betreffende Daten verarbeitet werden, auf Auskunft über die verarbeiteten Daten, auf weitere Informationen über die Datenverarbeitung sowie auf Kopien der Daten (vgl. auch Art. 15 DSGVO);
                    auf Berichtigung oder Vervollständigung unrichtiger bzw. unvollständiger Daten (vgl. auch Art. 16 DSGVO);
                    auf unverzügliche Löschung der sie betreffenden Daten (vgl. auch Art. 17 DSGVO), oder, alternativ, soweit eine weitere Verarbeitung gemäß Art. 17 Abs. 3 DSGVO erforderlich ist, auf Einschränkung der Verarbeitung nach Maßgabe von Art. 18 DSGVO;
                    auf Erhalt der sie betreffenden und von ihnen bereitgestellten Daten und auf Übermittlung dieser Daten an andere Anbieter/Verantwortliche (vgl. auch Art. 20 DSGVO);
                    auf Beschwerde gegenüber der Aufsichtsbehörde, sofern sie der Ansicht sind, dass die sie betreffenden Daten durch den Anbieter unter Verstoß gegen datenschutzrechtliche Bestimmungen verarbeitet werden (vgl. auch Art. 77 DSGVO).
                    Darüber hinaus ist der Anbieter dazu verpflichtet, alle Empfänger, denen gegenüber Daten durch den Anbieter offengelegt worden sind, über jedwede Berichtigung oder Löschung von Daten oder die Einschränkung der Verarbeitung, die aufgrund der Artikel 16, 17 Abs. 1, 18 DSGVO erfolgt, zu unterrichten. Diese Verpflichtung besteht jedoch nicht, soweit diese Mitteilung unmöglich oder mit einem unverhältnismäßigen Aufwand verbunden ist. Unbeschadet dessen hat der Nutzer ein Recht auf Auskunft über diese Empfänger.
                    Ebenfalls haben die Nutzer und Betroffenen nach Art. 21 DSGVO das Recht auf Widerspruch gegen die künftige Verarbeitung der sie betreffenden Daten, sofern die Daten durch den Anbieter nach Maßgabe von Art. 6 Abs. 1 lit. f) DSGVO verarbeitet werden. Insbesondere ist ein Widerspruch gegen die Datenverarbeitung zum Zwecke der Direktwerbung statthaft.
                    <br>
                  </div>
                  <br>
                  <div class="AGBbox">
                    <strong class="AGBheading">III. Informationen zur Datenverarbeitung</strong>
                    <br>Ihre bei Nutzung unseres Internetauftritts verarbeiteten Daten werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt, der Löschung der Daten keine gesetzlichen Aufbewahrungspflichten entgegenstehen und nachfolgend keine anderslautenden Angaben zu einzelnen Verarbeitungsverfahren gemacht werden.
                    <h4>Serverdaten</h4>
                    Aus technischen Gründen, insbesondere zur Gewährleistung eines sicheren und stabilen Internetauftritts, werden Daten durch Ihren Internet-Browser an uns bzw. an unseren Webspace-Provider übermittelt. Mit diesen sog. Server-Logfiles werden u.a. Typ und Version Ihres Internetbrowsers, das Betriebssystem, die Website, von der aus Sie auf unseren Internetauftritt gewechselt haben (Referrer URL), die Website(s) unseres Internetauftritts, die Sie besuchen, Datum und Uhrzeit des jeweiligen Zugriffs sowie die IP-Adresse des Internetanschlusses, von dem aus die Nutzung unseres Internetauftritts erfolgt, erhoben.
                    Diese so erhobenen Daten werden vorrübergehend gespeichert, dies jedoch nicht gemeinsam mit anderen Daten von Ihnen.
                    Diese Speicherung erfolgt auf der Rechtsgrundlage von Art. 6 Abs. 1 lit. f) DSGVO. Unser berechtigtes Interesse liegt in der Verbesserung, Stabilität, Funktionalität und Sicherheit unseres Internetauftritts.
                    Die Daten werden spätestens nach sieben Tage wieder gelöscht, soweit keine weitere Aufbewahrung zu Beweiszwecken erforderlich ist. Andernfalls sind die Daten bis zur endgültigen Klärung eines Vorfalls ganz oder teilweise von der Löschung ausgenommen.
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue" small text @click="dialog = false">OK</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
             <div v-if="!$store.state.auth.loading">
              <v-flex>
                <v-btn color="blue" @click="register" :disabled="!valid" small style="color: white">Registrieren</v-btn>
              </v-flex>
             </div>
              <div v-else>
                <v-progress-linear
                  color="blue accent-4"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </div>
              <v-alert v-if="$store.state.auth.error && !$store.state.auth.loading" type="error" outlined>
                {{$store.state.auth.error.statusText}}
              </v-alert>
          </div>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      // validation stuff
      valid: false,
      nameRules: [
        v => !!v || 'Name ist erforderlich',
      ],
      emailRules: [
        v => !!v || 'E-mail ist erforderlich',
        v => /.+@.+/.test(v) || 'E-mail muss gültig sein',
      ],
      passwordRules: [
        v => !!v || 'Passwort is erforderlich',
        v => v.length >= 8 || 'Passwort muss mindestens 8 Zeichen haben',
      ],

      firstName: "",
      lastName: "",
      skiName: "",
      eMail: "",
      password: "",
      accepted: false,
      dialog: false
    };
  },
  methods: {
    register() {
      console.log(this.valid);
      if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      if (!this.valid) {
        return
      }

      var cred = { firstName: this.firstName, 
        lastName: this.lastName,
        email: this.eMail.toLowerCase(),
        password: this.password,
        confirm_password: this.password,
        receive_email: false }
      console.log('registering....', cred)
      this.$store.dispatch('auth/signup', cred)
    }
  }
};
</script>

<style scoped>
.Register {
  text-align: center;
}

#reg {
  background-color: white;
  width: 80%;
  margin: 5% auto 0% auto;
  border: 2px solid black;
  border-radius: 5px;
  opacity: 0.85;
  filter: alpha(opacity=85);
}

#regHeading {
  font-size: 200%;
}

table {
  margin-left: auto;
  margin-right: auto;
}

#Login {
  float: left;
}

.txtField {
  width: 90%;
  margin-left: 5%;
}

tr {
  margin-top: 50%;
  margin-left: 50%;
}

#vbtn {
  width: 50%;
}

.AGBheading {
  font-size: 150%;
}

.AGBbox {
  border: 1px solid black;
  border-radius: 10px;
  padding: 5px;
}
</style>
